import { isValidPhoneNumber } from "libphonenumber-js";

const isPhoneNumberValid = (phoneNumber: string): boolean => {
  const isMeetingRequirements = phoneNumber.length <= 15 && /^\+?[0-9]*$/.test(phoneNumber);
  const isValid = isValidPhoneNumber(phoneNumber);

  return isMeetingRequirements && isValid;
};

export default isPhoneNumberValid;
